// This is the shared version for all of the js packages
// Update the version here and merge your code to main to
// publish a new version of all of the packages to npm.

const version = 'v1.0.52';

export { version };
